<template>
  <v-dialog
    v-model="input"
    persistent
    max-width="800"
  >
    <v-card>
      <template v-if="!accepted">
        <!-- ===== HEADER ===== -->
        <v-card-title class="tnc-header">
          <div>
            <div class="tnc-title">
              Revised Dealer Appointment Terms & Conditions
            </div>
            <div class="tnc-subtitle">
              Mandatory Digital Acceptance
            </div>
            <div class="tnc-note">
              All dealers must digitally accept the revised Dealer Appointment Terms & Conditions (“T&C”).<br>
              Please scroll to the end before ticking the checkboxes.
            </div>
          </div>
        </v-card-title>

        <v-divider />

        <!-- ===== SCROLLABLE TNC ===== -->
        <v-card-text>
          <div
            ref="tncBox"
            class="tnc-scroll tnc-text"
            @scroll="onScroll"
            v-html="tncContent"
          />
        </v-card-text>

        <v-divider />

        <!-- ===== CHECKBOXES ===== -->
        <v-card-text>
          <v-checkbox
            v-for="(item, i) in checkboxes"
            :key="i"
            v-model="item.checked"
            :label="item.label"
            :disabled="!hasScrolledEnd"
          />
        </v-card-text>

        <v-divider />

        <!-- ===== ACTION ===== -->
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            :disabled="!allChecked"
            @click="accept"
          >
            Accept & Continue
          </v-btn>
        </v-card-actions>
      </template>

      <!-- ✅ THANK YOU STATE -->
      <template v-else>
        <v-card-title class="headline">
          Thank You
        </v-card-title>

        <v-card-text>
          <p>
            Thank you for your response. Your acceptance of the revised
            Dealer Appointment Terms & Conditions has been recorded successfully.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="closeDialog"
          >
            OK
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import dealerTncContent from '@/components/DealerTncContent'
import { createPostParams } from '@/rest'

export default {
  name: 'DealerTnc',

  props: {
    value: { type: Boolean, required: true },
  },

  data () {
    return {
      input: false,
      hasScrolledEnd: false,
      loading: false,
      accepted: false,
      tncContent: dealerTncContent,

      checkboxes: [
        {
          label: 'I confirm that I have read and understood these revised Dealer Appointment Terms & Conditions (T&C), and I agree to be bound by them.',
          checked: false,
        },
        {
          label: 'I acknowledge that I have been given the opportunity to seek clarification from my upline or XOX in respect of any portion that i do not understand.',
          checked: false,
        },
        {
          label: 'I acknowledge that my continued access to or use of the Dealer Platform and/or continued dealership as XOX`s Authorised Dealer after notification of these T&C constitutes my continued acceptance of the same.',
          checked: false,
        },
        {
          label: 'I acknowledge that my electronic acceptance constitutes a valid and legally binding agreement.',
          checked: false,
        },
      ],
    }
  },

  computed: {
    allChecked () {
      return (
        this.hasScrolledEnd &&
        this.checkboxes.every(c => c.checked)
      )
    },
  },

  watch: {
    value (val) {
      this.input = val
      document.body.style.overflow = val ? 'hidden' : ''
    },
  },

  mounted () {
    this.input = this.value
  },

  beforeDestroy () {
    document.body.style.overflow = ''
  },

  methods: {
    onScroll () {
      const el = this.$refs.tncBox
      if (!el) return

      const reachedBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 5

      if (reachedBottom) {
        this.hasScrolledEnd = true
      }
    },

    async accept () {
      const payload = {
        tnc_read: 1,
        tnc_clarify: 1,
        tnc_accept: 1,
        tnc_esign: 1,
      }

      const params = createPostParams({
        action: 'acceptDealerTnc',
        payload,
      })

      try {
        this.loading = true
        await this.$rest.post('postAction.php', params)
        this.accepted = true // 👈 SHOW THANK YOU
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    closeDialog () {
      document.body.style.overflow = ''
      this.input = false
      this.$emit('input', false)
      this.$emit('accepted')
    },
  },
}
</script>

<style scoped>
/* ===== HEADER ===== */
.tnc-header {
  background: #4a4a4a;
  color: #ffffff;
}

.tnc-title {
  font-size: 20px;
  font-weight: bold;
}

.tnc-subtitle {
  margin-top: 4px;
  font-weight: bold;
}

.tnc-note {
  margin-top: 8px;
  font-size: 13px;
}

/* ===== SCROLL AREA ===== */
.tnc-scroll {
  height: 420px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 16px;
  background: #ffffff;
}

/* ===== TNC TEXT ===== */
.tnc-text {
  font-family: Calibri, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #000000;
}
</style>
